import type * as Types from '@hotelplan/supergraph-api';

import type { DocumentNode } from 'graphql';
import { FdrHeroFragmentDoc } from 'schemas/fragment/regular/fdrHero.generated';
import { FdrWebMetaFragmentDoc } from 'schemas/fragment/web-meta/fdr-web-meta.generated';
import { FdrRequestButtonFragmentDoc } from 'schemas/fragment/request-button/fdr-request-button.generated';
import { FdrBoosterFragmentDoc } from 'schemas/fragment/booster/fdr-booster.generated';
import type * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@hotelplan/fdr.lib.apollo.query';
const defaultOptions = {} as const;
export type FdrThemeContentQueryVariables = Types.Exact<{
  input: Types.FdrThemeInput;
  heroCriteria: Array<Types.FdrImageCriteria> | Types.FdrImageCriteria;
}>;

export type FdrThemeContentQuery = {
  __typename?: 'Query';
  fdrTheme?: {
    __typename?: 'FdrTheme';
    tagLine?: { __typename?: 'FdrTagline'; text: string } | null;
    hero?: {
      __typename?: 'FdrImage';
      alt: string;
      description?: string | null;
      copyright?: string | null;
      rawUrl: string;
      resized: Array<{
        __typename?: 'FdrResizedImage';
        id: string;
        link: {
          __typename?: 'FdrLink';
          openMethod?: Types.FdrLinkOpenMethod | null;
          legacyUrl?: string | null;
          type: Types.FdrLinkType;
          url: string;
        };
      }>;
    } | null;
    webMeta: {
      __typename?: 'FdrThemeWebMeta';
      descriptionWebMeta?: {
        __typename?: 'FdrMeta';
        title: string;
        description: string;
        index: boolean;
        noFollow: boolean;
        sitemap: boolean;
        link: {
          __typename?: 'FdrLink';
          openMethod?: Types.FdrLinkOpenMethod | null;
          legacyUrl?: string | null;
          type: Types.FdrLinkType;
          url: string;
        };
      } | null;
    };
    requestButton: {
      __typename?: 'FdrRequestButton';
      staticCaption: string;
      objectCaption?: string | null;
      link: {
        __typename?: 'FdrLink';
        openMethod?: Types.FdrLinkOpenMethod | null;
        legacyUrl?: string | null;
        type: Types.FdrLinkType;
        url: string;
      };
    };
    boosters?: Array<{
      __typename?: 'FdrBooster';
      id: string;
      mainText: string;
      frequency?: Types.BoosterFrequency | null;
      duration: number;
      delay?: number | null;
    }> | null;
  } | null;
};

export const FdrThemeContentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FdrThemeContent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FdrThemeInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'heroCriteria' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'FdrImageCriteria' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fdrTheme' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tagLine' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'fdrHero' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'webMeta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'descriptionWebMeta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fdrWebMeta' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requestButton' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'fdrRequestButton' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'boosters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'fdrBooster' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...FdrHeroFragmentDoc.definitions,
    ...FdrWebMetaFragmentDoc.definitions,
    ...FdrRequestButtonFragmentDoc.definitions,
    ...FdrBoosterFragmentDoc.definitions,
  ],
} as unknown as DocumentNode;

/**
 * __useFdrThemeContentQuery__
 *
 * To run a query within a React component, call `useFdrThemeContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFdrThemeContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFdrThemeContentQuery({
 *   variables: {
 *      input: // value for 'input'
 *      heroCriteria: // value for 'heroCriteria'
 *   },
 * });
 */
export function useFdrThemeContentQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    FdrThemeContentQuery,
    FdrThemeContentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    FdrThemeContentQuery,
    FdrThemeContentQueryVariables
  >(FdrThemeContentDocument, options);
}
export function useFdrThemeContentLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FdrThemeContentQuery,
    FdrThemeContentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    FdrThemeContentQuery,
    FdrThemeContentQueryVariables
  >(FdrThemeContentDocument, options);
}
export type FdrThemeContentQueryHookResult = ReturnType<
  typeof useFdrThemeContentQuery
>;
export type FdrThemeContentLazyQueryHookResult = ReturnType<
  typeof useFdrThemeContentLazyQuery
>;
export type FdrThemeContentQueryResult = Apollo.QueryResult<
  FdrThemeContentQuery,
  FdrThemeContentQueryVariables
>;
